module.exports = __webpack_public_path__ + "files/10bdaa435a58f1832cb326f01b1653e1.png";